export default __webpack_public_path__ + "static/media/4.b28788ab.png";